var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{staticClass:"px-0",attrs:{"fluid":""}},[_c('b-row',{staticClass:"mx-0",attrs:{"align-h":"between","align-v":"center"}},[_c('b-col',{attrs:{"cols":"auto"}},[_vm._t("default",function(){return [_c('div',{staticClass:"esg-title"},[_vm._v(_vm._s(_vm.title))])]})],2),_c('b-col',{staticClass:"actions"},[_vm._t("actions")],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }